const DEFAULT_TIMEZONE = 'Europe/Copenhagen'
export default DEFAULT_TIMEZONE
